<main class="multi-step">
  <!-- Step 1: Welcome Screen -->
  <section class="multi-step__step" *ngIf="currentStep === 1">
    <div class="welcome">
      <div class="welcome__content">
        <span class="welcome__title">Welcome to INSCYD</span>
        <p class="welcome__description">
          Let's create your first metabolic profile. If you have no real test data yet, you can start by reviewing
          example data - here you can also learn the application of the data.
        </p>
        <button type="button" class="welcome__button" mat-raised-button color="primary" (click)="onGetStarted()">
          Let's Get Started
        </button>
      </div>
    </div>
  </section>

  <!-- Step 2: Button Selection Screen -->
  <section class="multi-step__step" *ngIf="currentStep === 2">
    <div class="selection">
      <div class="selection__content">
        <span class="selection__question">How Would You Like to Start?</span>
        <p class="selection__subtitle">Please chose the type of data you want to proceed with:</p>

        <div class="selection__actions">
          <button class="selection__action-button" mat-raised-button (click)="onExploreUseCases()" type="button">
            Explore use cases
          </button>
          <button class="selection__action-button" mat-raised-button (click)="onExploreUseCases2()" type="button">
            Explore use cases 2
          </button>
          <button class="selection__action-button" mat-raised-button (click)="onProceedWithLactate()" type="button">
            Proceed with Lactate
          </button>
          <button class="selection__action-button" mat-raised-button (click)="onProceedWithPPD()" type="button">
            Proceed with PPD
          </button>
        </div>
      </div>
    </div>
  </section>
</main>
